import MuiCard from '@mui/material/Card';
import type { CardProps } from './ICard';
import { styles } from './styles';

const Card = ({ sx, ...rest }: CardProps) => (
    <MuiCard
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default Card;
